import { render, staticRenderFns } from "./ProductCommentEdit.vue?vue&type=template&id=73ecec08&scoped=true&"
import script from "./ProductCommentEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ecec08",
  null
  
)

export default component.exports